import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { message } from "../../../Reducers/loading/actions";

const AIContentstijlGids = ({ token, dispatch }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [settings, setSettings] = useState({
    toon: "professioneel en toegankelijk",
    doelgroep: "campinggasten en recreanten",
    schrijfstijl: "vriendelijk, informatief en behulpzaam",
    taalgebruik: "Nederlands, informeel maar respectvol",
    woordkeuze: "helder en begrijpelijk, vermijd jargon",
    zinsbouw: "korte tot middellange zinnen, actieve vorm",
    structuur: "gebruik koppen, opsommingen en witruimte",
    call_to_action: "duidelijk en uitnodigend",
    vermijd: "technische termen zonder uitleg, lange paragrafen, passieve vorm",
    voorkeuren: "persoonlijke aanspreken, seizoensreferenties, lokale context",
    seo_focus: "zoekwoorden natuurlijk integreren",
    merkidentiteit: "RecraPlan - natuurlijk, gastvrij, professioneel"
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const response = await fetch("/api/admin/cms/settings/ai-contentstijl", {
        headers: {
          Authorization: `Bearer ${token.token}`,
          "Content-Type": "application/json",
        },
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data && Object.keys(data).length > 0) {
          setSettings({ ...settings, ...data });
        }
      }
    } catch (error) {
      console.error("Fout bij ophalen instellingen:", error);
    }
    setLoading(false);
  };

  const saveSettings = async () => {
    setSaving(true);
    try {
      const response = await fetch("/api/admin/cms/settings/ai-contentstijl", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token.token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(settings),
      });

      if (response.ok) {
        dispatch(message(3000, "success", "AI contentstijl-gids succesvol opgeslagen!"));
      } else {
        dispatch(message(3000, "error", "Fout bij opslaan instellingen"));
      }
    } catch (error) {
      dispatch(message(3000, "error", "Fout bij opslaan instellingen"));
      console.error("Save error:", error);
    }
    setSaving(false);
  };

  const handleInputChange = (field, value) => {
    setSettings({
      ...settings,
      [field]: value,
    });
  };

  const resetToDefaults = () => {
    setSettings({
      toon: "professioneel en toegankelijk",
      doelgroep: "campinggasten en recreanten",
      schrijfstijl: "vriendelijk, informatief en behulpzaam",
      taalgebruik: "Nederlands, informeel maar respectvol",
      woordkeuze: "helder en begrijpelijk, vermijd jargon",
      zinsbouw: "korte tot middellange zinnen, actieve vorm",
      structuur: "gebruik koppen, opsommingen en witruimte",
      call_to_action: "duidelijk en uitnodigend",
      vermijd: "technische termen zonder uitleg, lange paragrafen, passieve vorm",
      voorkeuren: "persoonlijke aanspreken, seizoensreferenties, lokale context",
      seo_focus: "zoekwoorden natuurlijk integreren",
      merkidentiteit: "RecraPlan - natuurlijk, gastvrij, professioneel"
    });
  };

  if (loading) {
    return (
      <div className="content-page">
        <div className="modern-cms-settings">
          <div className="settings-content">
            <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Laden...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content-page">
      <div className="modern-cms-settings">
        <div className="settings-content">
          {/* Header */}
          <div className="settings-header">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <h1>
                  <i className="fas fa-robot me-3"></i>
                  AI Contentstijl-gids
                </h1>
                <p>
                  Definieer de schrijfstijl en richtlijnen voor AI-gegenereerde content om consistentie en merkidentiteit te waarborgen.
                </p>
              </div>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-outline-secondary"
                  onClick={resetToDefaults}
                  disabled={saving}
                >
                  <i className="fas fa-undo me-2"></i>
                  Reset naar standaard
                </button>
                <button
                  className="btn btn-primary"
                  onClick={saveSettings}
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <div className="spinner-border spinner-border-sm me-2" role="status">
                        <span className="visually-hidden">Opslaan...</span>
                      </div>
                      Opslaan...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save me-2"></i>
                      Opslaan
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Algemene Stijl */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h5>
                    <i className="fas fa-palette me-2"></i>
                    Algemene Stijl
                  </h5>
                </div>
                <div className="card-body">
                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-volume-up me-2"></i>
                      Toon van de Content
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={settings.toon}
                      onChange={(e) => handleInputChange("toon", e.target.value)}
                      placeholder="Bijvoorbeeld: professioneel en toegankelijk"
                    />
                    <div className="form-text">Hoe moet de AI klinken in de content?</div>
                  </div>

                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-users me-2"></i>
                      Doelgroep
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={settings.doelgroep}
                      onChange={(e) => handleInputChange("doelgroep", e.target.value)}
                      placeholder="Bijvoorbeeld: campinggasten en recreanten"
                    />
                    <div className="form-text">Voor wie wordt de content geschreven?</div>
                  </div>

                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-pen-fancy me-2"></i>
                      Schrijfstijl
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={settings.schrijfstijl}
                      onChange={(e) => handleInputChange("schrijfstijl", e.target.value)}
                      placeholder="Bijvoorbeeld: vriendelijk, informatief en behulpzaam"
                    />
                    <div className="form-text">Welke eigenschappen moet de schrijfstijl hebben?</div>
                  </div>

                  <div className="mb-0">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-flag me-2"></i>
                      Taalgebruik
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={settings.taalgebruik}
                      onChange={(e) => handleInputChange("taalgebruik", e.target.value)}
                      placeholder="Bijvoorbeeld: Nederlands, informeel maar respectvol"
                    />
                    <div className="form-text">Welke taal en formaliteit?</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Technische Richtlijnen */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h5>
                    <i className="fas fa-cogs me-2"></i>
                    Technische Richtlijnen
                  </h5>
                </div>
                <div className="card-body">
                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-spell-check me-2"></i>
                      Woordkeuze
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={settings.woordkeuze}
                      onChange={(e) => handleInputChange("woordkeuze", e.target.value)}
                      placeholder="Bijvoorbeeld: helder en begrijpelijk, vermijd jargon"
                    />
                  </div>

                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-align-left me-2"></i>
                      Zinsbouw
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={settings.zinsbouw}
                      onChange={(e) => handleInputChange("zinsbouw", e.target.value)}
                      placeholder="Bijvoorbeeld: korte tot middellange zinnen, actieve vorm"
                    />
                  </div>

                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-sitemap me-2"></i>
                      Structuur
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={settings.structuur}
                      onChange={(e) => handleInputChange("structuur", e.target.value)}
                      placeholder="Bijvoorbeeld: gebruik koppen, opsommingen en witruimte"
                    />
                  </div>

                  <div className="mb-0">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-mouse-pointer me-2"></i>
                      Call-to-Action
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={settings.call_to_action}
                      onChange={(e) => handleInputChange("call_to_action", e.target.value)}
                      placeholder="Bijvoorbeeld: duidelijk en uitnodigend"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Wat te Vermijden */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h5>
                    <i className="fas fa-ban me-2"></i>
                    Wat te Vermijden
                  </h5>
                </div>
                <div className="card-body">
                  <div className="mb-0">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      Vermijd het Volgende
                    </label>
                    <textarea
                      className="form-control"
                      rows="4"
                      value={settings.vermijd}
                      onChange={(e) => handleInputChange("vermijd", e.target.value)}
                      placeholder="Bijvoorbeeld: technische termen zonder uitleg, lange paragrafen, passieve vorm"
                    />
                    <div className="form-text">Welke stijlelementen moeten worden vermeden?</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Speciale Voorkeuren */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h5>
                    <i className="fas fa-star me-2"></i>
                    Speciale Voorkeuren
                  </h5>
                </div>
                <div className="card-body">
                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-heart me-2"></i>
                      Voorkeuren
                    </label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={settings.voorkeuren}
                      onChange={(e) => handleInputChange("voorkeuren", e.target.value)}
                      placeholder="Bijvoorbeeld: persoonlijke aanspreken, seizoensreferenties, lokale context"
                    />
                  </div>

                  <div className="mb-0">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-search me-2"></i>
                      SEO Focus
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={settings.seo_focus}
                      onChange={(e) => handleInputChange("seo_focus", e.target.value)}
                      placeholder="Bijvoorbeeld: zoekwoorden natuurlijk integreren"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Merkidentiteit */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5>
                    <i className="fas fa-award me-2"></i>
                    Merkidentiteit & Brand Voice
                  </h5>
                </div>
                <div className="card-body">
                  <div className="mb-0">
                    <label className="form-label fw-semibold">
                      <i className="fas fa-fingerprint me-2"></i>
                      Merkidentiteit
                    </label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={settings.merkidentiteit}
                      onChange={(e) => handleInputChange("merkidentiteit", e.target.value)}
                      placeholder="Bijvoorbeeld: RecraPlan - natuurlijk, gastvrij, professioneel"
                    />
                    <div className="form-text">
                      Beschrijf de kernwaarden en persoonlijkheid van het merk die in de content moeten doorklinken.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Preview Box */}
          <div className="row">
            <div className="col-12">
              <div className="card border-success">
                <div className="card-header bg-success text-white">
                  <h5 className="mb-0">
                    <i className="fas fa-eye me-2"></i>
                    Voorbeeld AI Prompt
                  </h5>
                </div>
                <div className="card-body">
                  <div className="alert alert-info">
                    <strong>Deze instellingen worden automatisch toegevoegd aan AI prompts:</strong>
                  </div>
                  <div className="bg-light p-3 rounded">
                    <small className="text-muted">
                      Schrijf content voor <strong>{settings.doelgroep}</strong> in een <strong>{settings.toon}</strong> toon. 
                      Gebruik een <strong>{settings.schrijfstijl}</strong> schrijfstijl in het <strong>{settings.taalgebruik}</strong>. 
                      Zorg voor <strong>{settings.woordkeuze}</strong> en gebruik <strong>{settings.zinsbouw}</strong>. 
                      Structureer de content door <strong>{settings.structuur}</strong> te gebruiken. 
                      Maak call-to-actions <strong>{settings.call_to_action}</strong>.
                      <br/><br/>
                      <strong>Vermijd:</strong> {settings.vermijd}
                      <br/>
                      <strong>Voorkeuren:</strong> {settings.voorkeuren}
                      <br/>
                      <strong>SEO:</strong> {settings.seo_focus}
                      <br/>
                      <strong>Merkidentiteit:</strong> {settings.merkidentiteit}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.token,
});

export default connect(mapStateToProps)(AIContentstijlGids);